{
  "onboarding.cta.complete": "Enter service",
  "onboarding.cta.continue": "Continue",
  "onboarding.notifications.disclosure": "Notifications are not yet active in this demo build.",
  "onboarding.notifications.toggle.messages": "Allow messages",
  "onboarding.notifications.toggle.system": "Allow notifications",
  "onboarding.progress.ariaLabel": "Onboarding progress",
  "onboarding.skip": "Skip",
  "onboarding.step.lakikaveri.body": "When a tricky question about employment law or pay arises at work, you can turn to Lakikaveri.",
  "onboarding.step.lakikaveri.title": "Legal assistant at hand",
  "onboarding.step.notifications.body": "Get notified about messages received in the service. You can manage all communication settings in your profile. Remember to add the service to your home screen.",
  "onboarding.step.notifications.title": "Allow notifications",
  "onboarding.step.training.body": "Access training and coaching for free through the service. You will also find valuable leisure benefits.",
  "onboarding.step.training.title": "Training and benefits",
  "onboarding.step.welcome.body": "Through the service you can get in touch, find diverse training opportunities, and enjoy leisure benefits.",
  "onboarding.step.welcome.title": "Your service is ready"
}
